export const TENURE_DATA = "TENURE_DATA";
export const TENURE_ERROR_DATA = "TENURE_ERROR_DATA";
export const TENURE_HIDE_ERROR_DATA = "TENURE_HIDE_ERROR_DATA";
export const TENURE_START_LOADER = "TENURE_START_LOADER";
export const TENURE_STOP_LOADER = "TENURE_STOP_LOADER";
